import type { Step } from '@types'
import axios from 'axios'

import env from '../environments'

export async function createStep(
	applicationId: string,
	name: string,
	type: 'document' | 'prompt',
	index: number,
	skippable: boolean,
	description?: string
) {
	const response = await axios.post(`${env.apiUrl}/steps`, {
		applicationId,
		name,
		type,
		index,
		description,
		skippable
	})

	return (response.data as {step: Step}).step
}

export async function updateStep(stepId: string, step: Partial<Step>) {
	const response = await axios.put(`${env.apiUrl}/steps/${stepId}`, step)

	return (response.data as {step: Step}).step
}

export async function deleteStep(stepId: string) {
	await axios.delete(`${env.apiUrl}/steps/${stepId}`)
}
